<template>
  <div class="px-5 px-sm-15 pt-5 py-10 ota-info">
    <template v-if="hasWritePermission">
      <div class="action-buttons">
        <v-btn
          outlined
          small
          color="var(--text__red-dark)"
          @click="cancelClick"
        >
          OTA予約キャンセル
        </v-btn>
        <v-btn
          outlined
          small
          color="var(--text__red-dark)"
          @click="moveClick"
        >
          OTA予約減泊
        </v-btn>
      </div>
      <SettingMoveDialog
        v-if="showMoveDialog && booking"
        :bookingId="booking.id"
        :oldCheckInDate="booking.checkInDate"
        :oldCheckOutDate="booking.checkOutDate"
        :bookingTypeId="booking.bookingTypeId"
        hideFeeOverwrite
        @close="showMoveDialog = false"
      />
    </template>
    <template v-if="bookingGroupOtaHistory">
      <div v-for="(item, ind) in bookingGroupOtaHistory" :key="item.id">
        <div v-if="item.changedAt" class="text--large text--prm mb-2" :class="ind ? 'mt-2' : ''" >
          {{ item.changedAt | dateTimeSting }} 受信 {{ translateOtaBookingType(item.otaBookingType) }}
        </div>
        <div style="background-color: var(--bg__gray); padding: 15px; border-radius: 5px;">
          <FormatSpan :value="item.otaSpecialRequest" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import FormatSpan from '@/components/shared/FormatSpan.vue';
import { getPermissionLevel } from '../../../utils/permissions';
import SettingMoveDialog from './settingMoveDialog.vue';

export default {
  name: 'OTAInfo',
  components: { FormatSpan, SettingMoveDialog },
  props: {
    bookingId: Number,
    bookingGroupId: Number,
  },
  data () {
    return {
      bookingGroupOtaHistory: null,
      showMoveDialog: false,
      booking: null,
    }
  },
  computed: {
    hasWritePermission() {
      return getPermissionLevel('/reservation/contract-detail?type=SP&tab=ota-info') === 'W';
    },
  },
  mounted () {
    this.getBookingGroupOtaHistory()
  },
  methods: {
    async getBookingGroupOtaHistory () {
      const result = await this.$gqlLoading({
        query: gql`query bookingGroupOtaHistory ($id: Int!) {
          bookingGroupOtaHistory(bookingGroupId: $id) {
            id
            changedAt
            otaSpecialRequest
            otaBookingType
          }
        }`,
        variables: {
          id: this.bookingGroupId,
        },
      })
      this.bookingGroupOtaHistory = result.data.bookingGroupOtaHistory

      if (this.bookingGroupOtaHistory.length === 0) {
        // this means this OTA booking was created before the history was added.
        // in that case get the bookingGroup and show the current data
        this.bookingGroupOtaHistory = null
        const bgResult = await this.$gqlLoading({
          query: gql`query getBookingGroupForOTAInfo ($id: Int!) {
            bookingGroup(id: $id) {
              id
              otaSpecialRequest
            }
          }`,
          variables: {
            id: this.bookingGroupId,
          },
        })
        this.bookingGroupOtaHistory = [{
          id: bgResult.data.bookingGroup.id,
          otaSpecialRequest: bgResult.data.bookingGroup.otaSpecialRequest,
          changedAt: null,
        }]
      }
    },
    cancelClick() {
      this.$confirm({
        message: `OTAサイトよりキャンセル・ノーショウ処理ができない場合のみ使用可。
キャンセルしますか？`,
        okText: '予約をキャンセル',
        cancelText: '閉じる',
        reverseColors: true,
        ok: async () => {
          await this.$gqlLoading(`mutation cancelOtaBooking ($id: Int!) {
              cancelOtaBooking(bookingId: $id) {
                booking { id }
              }
            }`, {
              id: this.bookingId,
            },
          );
          this.$success(this.$t('messages.cancelComplete'));
        },
      })
    },
    async moveClick() {
      this.$confirm({
        message: `ＯＴＡ管理画面での減泊処理が、ＰＭＳに反映されない場合にのみ使用可。
減泊しますか？`,
        okText: '減泊処理開始',
        cancelText: '閉じる',
        reverseColors: true,
        ok: async () => {
          await this.loadBooking();
          this.showMoveDialog = true;
        },
      })
    },
    async loadBooking() {
      const result = await this.$gqlLoading({
        query: gql`
          query bookingForMove($id: Int!) {
            bookingForMove(id: $id) {
              id
              bookingTypeId
              checkInDate
              checkOutDate
            }
          }
        `,
        variables: {
          id: this.bookingId,
        },
      });

      this.booking = result.data.bookingForMove;
    },
    translateOtaBookingType(type) {
      if (!type) return '';
      switch (type) {
        case 'NewBookReport':
          return ' (新規)';
        case 'ModificationReport':
          return ' (更新)';
        case 'CancellationReport':
          return ' (キャンセル)';
        default:
          return type;
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.ota-info {
  position: relative;
  .action-buttons {
    position: absolute;
    top: 15px;
    right: 15px;
    display: flex;
    gap: 10px;
  }
}
</style>
